import { BankAllListResponse, loadTransportationAllResponse } from "services/interface";
import styled from "@emotion/styled";
import { Col, Row, message } from "antd";
import { FC } from "react";
import ShippingCard from "../ShippingCard";
import TableShippingList from "../TableShippingList";
import { useDeleteTransportationConfigs } from "hooks/useOrders";
 
interface ShippingListProps {
  data: loadTransportationAllResponse| undefined;
  refetch: () => void;
}

const ShippingList: FC<ShippingListProps> = ({
  data,
  refetch,
}) => {
  const { mutate:DeleteTransportationConfigs } = useDeleteTransportationConfigs();

  const onDeleteConfigs = (geography_id: number, transport_type: string, province_id: number | null, district_id: number | null) => {
    DeleteTransportationConfigs({
      geography_id,
      transport_type,
      province_id,
      district_id
    }, {
      onSuccess: (res) => {
        if (res.status === "success") {
          message.success("ลบสำเร็จ");
          refetch();
        } else {
          message.error(`ลบไม่สำเร็จ: ${res.error_message}`);
        }
      },
      onError: (error) => {
        message.error(`ลบไม่สำเร็จ: ${error.message}`);
      },
    });
  }


 

  return (
    <WrapperAll>
      <Row
        gutter={[16, 16]}
        style={{ backgroundColor: "#EFEFEF", overflow: "auto" }}
      >

      {/* { data && data?.data?.data?.map((item) => {
        return (
          <ShippingCard
            key={item.id}
            data={item}
            refetch={refetch}
            refetchTo={refetchTo}
          />
        );
      })} */}
        <Col span={24}>
        <CardWrapperTable>
        <TableShippingList data={data?.data} onDeleteConfigs={onDeleteConfigs}/>

        </CardWrapperTable>
        </Col>
      </Row>
    </WrapperAll>
  );
};

export default ShippingList;
const WrapperAll = styled.div`
  padding: 16px 0px 10px 0px;
  background-color: #efefef;
`;


const CardWrapperTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding: 5px;
`;
